import React from 'react';
/**
 * Gen 3 category page breadcrumb trail.
 */
export function Breadcrumb() {
  return <nav className="text-sm text-gray-500 mb-4" aria-label="Breadcrumb" data-id="element-576">
      <a href="/" className="hover:text-gray-900" data-id="element-577">
        Home
      </a>
      <span className="mx-2" data-id="element-578">/</span>
      <a href="/shop/" className="hover:text-gray-900" data-id="element-579">
        Shop
      </a>
      <span className="mx-2" data-id="element-580">/</span>
      <span className="text-gray-900 font-medium" data-id="element-581">Gen 3</span>
    </nav>;
}